import {BaseStore, globalStore} from "../../../stem-core/state/Store";
import {field} from "../../../stem-core/state/StoreField.js";
import {Money} from "../../../stem-core/localization/Money.js";
import {Currency} from "../../../stem-core/localization/CurrencyStore";


@globalStore
export class MerchantRevenue extends BaseStore("MerchantRevenue") {
    @field("Currency") currency: Currency;
    @field(Money) outstandingBalance: Money;
    @field(Money) allTimeRevenue: Money;
    @field(Money) last24hRevenue: Money;
    @field(Money) last30dRevenue: Money;
}
